import { CSSProperties } from 'react';
import { Navigate } from 'react-router-dom';
import { AgenticViewer } from '@amzn/work-spaces-agentic-web-viewer';
import '@amzn/work-spaces-agentic-web-viewer/styles.css';
import { CoreFactory } from '@/bridge/factory/CoreFactory';
import { useSessionStore } from '@/stores/session';

// The viewer tags its own lines and writes them through this logger, so they
// reach the same log upload as the rest of the client. One shared instance.
const logger = CoreFactory.getLogger();

// Fixed and viewport-sized: the viewer's docking shell fills its parent, so it
// needs a definite box, and pinning it to the viewport keeps route content
// reflowing underneath from disturbing it while it holds live sockets.
const containerStyle: CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  zIndex: 1000,
};

/*
 Route element for an active agentic session at /agentic. Maxibon writes the
 'wsp_context' handoff before it routes here, and the viewer reads that same
 handoff when it mounts. A cold deep-link with no handoff has nothing to connect
 to, so it falls back to the app entry rather than opening an empty viewer.
*/
const AgenticRoute: React.FC = () => {
  // Scope the viewer's saved chats to this WorkSpace. resourceId is the
  // GetResources ResourceId, persisted in the session store's sessionStorage,
  // so it is still present when /agentic is reloaded from the wsp_context
  // handoff. Empty means no WorkSpace, so hand the viewer undefined, not ''.
  const resourceId = useSessionStore((state) => state.resourceId);

  if (window.sessionStorage.getItem('wsp_context') === null) {
    return <Navigate to="/" replace />;
  }

  return (
    <div style={containerStyle}>
      <AgenticViewer workspaceId={resourceId || undefined} logger={logger} />
    </div>
  );
};

export default AgenticRoute;
